export const wrapEventListener = (target, eventListener) => {
    if (typeof eventListener === 'function') {
        return (event) => {
            const descriptor = { value: target };
            Object.defineProperties(event, {
                currentTarget: descriptor,
                target: descriptor
            });
            return eventListener.call(target, event);
        };
    }
    return eventListener;
};
//# sourceMappingURL=/build/es2018/helpers/wrap-event-listener.js.map